var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62875 0.09C7.56875 0.03 7.49542 0 7.40875 0C7.32208 0 7.24875 0.03 7.18875 0.09L2.27875 5L7.18875 9.91C7.24875 9.97 7.32208 10 7.40875 10C7.49542 10 7.56875 9.97 7.62875 9.91C7.68875 9.85 7.71875 9.77667 7.71875 9.69C7.71875 9.60333 7.68875 9.53 7.62875 9.47L3.15875 5L7.62875 0.53C7.68875 0.47 7.71875 0.396666 7.71875 0.31C7.71875 0.223333 7.68875 0.15 7.62875 0.09Z",
    fill: "#D93954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/right-chevron.c8d26be760099b0734eb07ea214f6e1d.svg";
export { ForwardRef as ReactComponent };